'use client';
import * as S from './styles.ts';
import { H1, P, VideoFrame } from '@template/components';

interface VideoSectionComponentProps {
  heading?: string;
  subHeading?: string;
  videoUrl?: string;
}

const VideoSectionComponent = ({
  heading,
  subHeading,
  videoUrl,
}: VideoSectionComponentProps) => {
  return (
    <S.VideoSectionWrapper>
      <S.VideoSectionContainer>
        <S.VideoSectionTextContainer>
          <H1 as='h2'>{heading}</H1>
          <P>{subHeading}</P>
        </S.VideoSectionTextContainer>
        <S.VideoFrameInnerContainer>
          <VideoFrame src={videoUrl} />
        </S.VideoFrameInnerContainer>
      </S.VideoSectionContainer>
    </S.VideoSectionWrapper>
  );
};

export default VideoSectionComponent;

export const options = [
  {
    description: '',
    displayName: 'VideoSectionComponent',
    methods: [],
    props: {
      heading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      subHeading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      videoUrl: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
    },
  },
];
